export default __webpack_public_path__ + "static/media/dick.6550c95a.png";